var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('MainNav'),_c('ShopTitle',{attrs:{"title":_vm.$t('shop.title')}}),(_vm.categories)?_c('ShopFilter',{attrs:{"categories":_vm.getAllCategories},on:{"categoryChange":_vm.handleCategoryChange}}):_vm._e(),_c('ShopProducts',{attrs:{"products":_vm.filteredProducts}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }